import { useEffect } from "react";
import { createPortal } from "react-dom";
import { RESPONSE_PREVIEW_APPLICANT_NAME } from "../lib/responseSettings";
import { stripEditorHtml } from "../lib/richTextEditor";

export default function RejectionResponsePreviewModal({
  open,
  onClose,
  title,
  responseHtml,
  signature,
  applicantName = RESPONSE_PREVIEW_APPLICANT_NAME,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (typeof document === "undefined" || !open) return null;

  const hasMessage = Boolean(stripEditorHtml(responseHtml));
  const signatureText = String(signature || "").trim();

  return createPortal(
    <div
      className="jw-recruitment-page response-settings-preview-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="response-settings-preview-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="response-settings-preview-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="response-settings-preview-dialog__head">
          <h2 id="response-settings-preview-title" className="response-settings-preview-dialog__title">
            {title}
          </h2>
          <button type="button" className="response-settings-preview-dialog__close" onClick={onClose} aria-label="Close preview">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="response-settings-preview-letter">
          <p className="response-settings-preview-letter__salutation">
            Dear{" "}
            <span className="response-settings-preview-letter__applicant-name">{applicantName}</span>
          </p>
          {hasMessage ? (
            <div
              className="job-body-html response-settings-preview-letter__message"
              dangerouslySetInnerHTML={{ __html: responseHtml }}
            />
          ) : (
            <p className="profile-manage-helper response-settings-preview-letter__message--empty">No message yet.</p>
          )}
          <p className="response-settings-preview-letter__signature">
            {signatureText || (
              <span className="response-settings-preview-letter__signature--empty">No signature yet.</span>
            )}
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
}
